import { Box, Chip, Divider, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { RelationshipStateChip } from './RelationshipStateChip.tsx';
import {
  daysSince,
  formatDaysAgo,
  personName,
  type CompanyRelationshipPath,
  type RelationshipPath
} from './relationshipApi.ts';

type PathRow = RelationshipPath & { contact?: CompanyRelationshipPath['contact'] };

// Colleagues in the API's order (score, highest first). Company rows also name
// the contact each colleague's best score runs through.
export const WhoKnowsThemList = ({ paths }: { paths: PathRow[] }) => (
  <Stack divider={<Divider />}>
    {paths.map((path) => {
      const days = daysSince(path.lastTouchAt);
      return (
        <Box
          key={path.user.id}
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1, flexWrap: 'wrap' }}
        >
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {path.user.fullName}
              </Typography>
              {path.isYou ? <Chip size="small" variant="outlined" label="You" /> : null}
            </Box>
            {path.contact ? (
              <Typography variant="body2" color="text.secondary">
                via{' '}
                <MuiLink
                  component={RouterLink}
                  to={`/contacts/${path.contact.id}/show`}
                  underline="hover"
                >
                  {personName(path.contact)}
                </MuiLink>
                {path.contact.title ? `, ${path.contact.title}` : ''}
              </Typography>
            ) : null}
            {path.noExchangeYet ? (
              <Typography variant="body2" color="warning.main" sx={{ fontWeight: 600 }}>
                No reply yet
              </Typography>
            ) : null}
          </Box>
          <Stack direction="row" spacing={1.25} alignItems="center">
            <RelationshipStateChip state={path.state} />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 700,
                minWidth: 24,
                textAlign: 'right',
                fontVariantNumeric: 'tabular-nums'
              }}
            >
              {path.score}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 170 }}>
              {days === null ? 'No email on record' : `Last contact ${formatDaysAgo(days)}`}
            </Typography>
          </Stack>
        </Box>
      );
    })}
  </Stack>
);
